<template>
    <div class="support-popup" id="donate-now">
        <div class="support-popup-row" style="padding: unset; background: #1d2125">
<!--                <i class="popup-close" ><img src="/assets/images/close-icon.svg"/></i>-->
                <i class="popup-close fa-solid fa-x" style="z-index: 10000; color: white"></i>
            <div class="credit-card" style=" border: unset;">
                <div style="margin-top: 3rem">
                    <div>
                        <p style="color: white; font-size: 3rem;text-align: center">Contribute to The Cradle's journalism</p>
                    </div>
                    <p style="color: white;font-weight: unset; text-align: center">Donate to help us LEAD West Asia's media space</p>


                </div>


            </div>
            <div class="support-row">
                <footer style="padding-top: 0">
                    <div class="footer-Newsletter-input" style="height: 8rem; padding: unset !important;">
                        <div class="Newsletter-input" style="justify-content: center">
                            <button class="btn-mobile-fix" @click='f' style="margin: -20px 0 0 0; font-size: 1.5rem;width: unset !important;">
                                Donate Now
                            </button>
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DonateNowPopup",
    data() {
        return {
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }
    },

    methods: {
        f(){
            window.location.href = '/supportus'
        },
        copyTRONAddressToClipboard() {
            const address = 'TEyZtrShUqFdmHYeiqYyvMc3DnYWKrcSkV';

            navigator.clipboard.writeText(address);

            alert('Address copied to clipboard!');
        },

        copyBTCAddressToClipboard() {
            const address = 'bc1qd864czk7zrrvuf5uvm0f6fecfn78mt6w8e0356';

            navigator.clipboard.writeText(address);

            alert('Address copied to clipboard!');
        },
        submitSupport(response) {
            console.log(response)
            const form = this.$refs.support;
            form.submit();
        }
    },
    mounted() {
        window.submitSupport = this.submitSupport;
    }
}


</script>

<style scoped>
@media (max-width: 960px) {
    .btn-mobile-fix{
        transform: translateY(-8px);
    }
}
</style>
